import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '@/features/settings/components/settings-page'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/settings/')(
  {
    component: SettingsPage,
    beforeLoad: () => ({
      title: 'Settings',
      headerTitleKey: 'header.settings.title',
      headerDescriptionKey: 'header.settings.description',
    }),
  },
)
